"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExpediaFranceOrSpain = exports.getChannelsCount = exports.toggleChannelSelection = exports.getSubHeading = exports.getCheckedValue = void 0;
const constants_1 = require("../../../../entities/contracts/constants");
const getCheckedValue = (channelId, listingContracts) => {
    let isChecked = false;
    if (listingContracts && listingContracts.length > 0) {
        const listingContract = listingContracts.find((lc) => lc.channel_id === channelId);
        isChecked = !!(listingContract === null || listingContract === void 0 ? void 0 : listingContract.list_property);
    }
    return isChecked;
};
exports.getCheckedValue = getCheckedValue;
const getSubHeading = (affiliates) => affiliates > 0 ? `+${affiliates} affiliate channels.` : '';
exports.getSubHeading = getSubHeading;
const toggleChannelSelection = (key, listingContracts, customer) => {
    var _a;
    if (key === 'all') {
        return constants_1.CHANNELS.map((c) => newListingContract(customer, c.id));
    }
    else {
        const existing = listingContracts === null || listingContracts === void 0 ? void 0 : listingContracts.find((lc) => lc.channel_id === key);
        const restOfContracts = (_a = (listingContracts || [])) === null || _a === void 0 ? void 0 : _a.filter((lc) => lc.channel_id !== key);
        // Toggle contract
        if (existing) {
            return [...restOfContracts, Object.assign(Object.assign({}, existing), { list_property: !existing.list_property })];
        }
        else {
            return [...restOfContracts, newListingContract(customer, key)];
        }
    }
};
exports.toggleChannelSelection = toggleChannelSelection;
const getChannelsCount = (listingContracts) => {
    const selectedChannels = listingContracts ? listingContracts.filter((lc) => lc.list_property) : [];
    const channelCount = selectedChannels.length;
    const affiliateCount = constants_1.CHANNELS.reduce((total, current) => {
        if (!!selectedChannels.find((sc) => sc.channel_id === current.id)) {
            return total + current.affiliates.length;
        }
        return total;
    }, 0);
    return affiliateCount + channelCount;
};
exports.getChannelsCount = getChannelsCount;
const newListingContract = (customer, channel) => ({
    customer,
    list_property: true,
    channel_id: channel,
});
const isExpediaFranceOrSpain = (channelId, property) => (channelId === constants_1.Channel.EXPEDIA && (property.country_code === 'FR' || property.country_code === 'ES'));
exports.isExpediaFranceOrSpain = isExpediaFranceOrSpain;
//# sourceMappingURL=helpers.js.map